import clsx from 'clsx'
import { motion } from 'motion/react'
import { useState } from 'react'

type ToggleProps = {
    activeThumbIcon: React.ReactNode
    activeTrackIcon: React.ReactNode
    inactiveThumbIcon: React.ReactNode
    inactiveTrackIcon: React.ReactNode
    active?: boolean
    onChange?: (active: boolean) => void
}

export default function Toggle({
    activeThumbIcon,
    activeTrackIcon,
    inactiveThumbIcon,
    inactiveTrackIcon,
    active: controlledActive,
    onChange,
}: ToggleProps) {
    const [uncontrolledActive, setUncontrolledActive] = useState(false)
    const isControlled = controlledActive !== undefined
    const active = isControlled ? controlledActive : uncontrolledActive

    const toggle = () => {
        const next = !active
        if (!isControlled) {
            setUncontrolledActive(next)
        }
        onChange?.(next)
    }

    const thumbIcon = active ? activeThumbIcon : inactiveThumbIcon
    const trackIcon = active ? activeTrackIcon : inactiveTrackIcon

    return (
        <div className='relative flex justify-between items-center bg-white-stroke border-white-stroke-darker text-white-stroke-darker p-1.5 border rounded-full w-17 h-8'>
            <button
                type='button'
                className={clsx('absolute', active ? 'left-1.5' : 'right-1.5')}
                onClick={toggle}
            >
                {trackIcon}
            </button>
            <motion.div
                className='absolute flex justify-center items-center rounded-full w-9 h-9'
                initial={false}
                animate={{ x: active ? 26 : -8 }}
                transition={{
                    type: 'spring',
                    stiffness: 520,
                    damping: 28,
                    mass: 0.75,
                }}
            >
                <div className='flex justify-center items-center bg-blue-stroke rounded-full w-full h-full'>
                    <motion.button
                        type='button'
                        initial={false}
                        onClick={toggle}
                        className='relative flex justify-center items-center bg-blue-gradient border-2 border-blue-stroke rounded-full w-full h-full'
                    >
                        <div className='top-0.75 absolute bg-shine-gradient rounded-full w-4 h-4'></div>
                        <div className='flex justify-center items-center'>
                            {thumbIcon}
                        </div>
                    </motion.button>
                </div>
            </motion.div>
        </div>
    )
}
